const MARKUP_TAG_PATTERN = /<[^>]*>/g;

const MARKUP_SPACE_ENTITY_PATTERN = /&nbsp;|&#160;|&#x0*a0;/gi;

export function resolveVisibleMarkupText(
  value: string | null | undefined
): string | null {
  const trimmed = value?.trim() ?? '';

  if (trimmed === '') return null;

  const visibleText = trimmed
    .replace(MARKUP_TAG_PATTERN, '')
    .replace(MARKUP_SPACE_ENTITY_PATTERN, ' ')
    .trim();

  return visibleText === '' ? null : trimmed;
}
